<template>
<v-dialog scrollable="" v-model="val.dialogShow" max-width="600px">
    <v-card color="grey lighten-5">
        <v-toolbar size="120px" color="info">
            <v-toolbar-title class="white--text">  {{ $t('Search-Person') }} </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field solo hide-details v-model="searchTable" label="Kullanıcı Ara..." append-icon="search">
            </v-text-field>

        </v-toolbar>
        <v-card-text>
            <v-data-table :headers="tableheaders" :items="tabledata" :search="searchTable"  hide-actions class="elevation-1">
                <template slot="items" slot-scope="props">
                    <tr @click="Sec(props.item)">
                        <td>{{ props.item.AdSoyad }}</td>
                        <td>{{ props.item.Email }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</v-dialog>
</template>

<script>
import arksnackbar from '@/components/app/coper/comp/arksnackbar.vue'
import auth from '@/api/auth'

export default {
    components: {
        arksnackbar
    },

    props: ['value'],
    computed: {
        val: {
            get: function () {

                return this.value;
            },
            set: function (newValue) {

                this.$emit('input', newValue)
            },
        },
    },

    data() {
        return {
            dialogShow: false,
            searchTable:null,
            tableheaders: [{
                    text: this.$t('Name_Surname_label'),
                    value: 'AdSoyad'
                },
                {
                    text: this.$t('Email_label'),
                    value: 'Email'
                },
            ],
            tabledata: [],
        }
    },
    beforeMount:beforeMount,
    methods: {
        Sec: Sec,
    },
}

function Sec(v) {
    this.value.name = v.AdSoyad
    this.value.dialogShow = false;
}

function beforeMount(){
     this.tabledata = [];
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params = {
            MusteriID: credentials.MusteriID
        }
        this.$http.post(auth.API_URL + 'api/Register/WebUserSearch', params, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
            this.tabledata = response.body;
        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable-WebUserSearch'
                this.snackbar = true
            } else {
                this.text1 = 'Service Unavailable-WebUserSearch'
                this.snackbar = true
            }
        })
}


</script>
